/** Shared curated transaction detail row — flat key/value grid, operator-safe fields only. */
export const SOURCE_LABEL = {
  widget: 'Booking widget',
  kiosk_direct: 'Kiosk',
  internal: 'On-dock booking',
  payment_link: 'Payment link',
  collect_balance: 'Balance collection',
  customer_ticket: 'Customer ticket',
  extras_checkout: 'Extras',
};

export const TxDetailRow = ({ colSpan, pairs, testId }) => (
  <tr className="border-b border-gray-100 bg-gray-50/50">
    <td colSpan={colSpan} className="px-4 py-3">
      <div data-testid={testId} className="grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-0.5 max-w-2xl">
        {pairs
          .filter(([, v]) => v !== null && v !== undefined && v !== '' && v !== 0)
          .map(([k, v]) => (
            <div key={k} className="flex gap-2 text-[12px] py-0.5">
              <span className="text-gray-400 shrink-0 w-32">{k}</span>
              <span className="text-gray-700 break-all">{String(v)}</span>
            </div>
          ))}
      </div>
    </td>
  </tr>
);
